import React from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './ResultadoPopup.css';

const nivelesLiderazgo = {
  'Liderazgo en desarrollo': {
    rango: '0 - 20',
    texto: 'Este nivel refleja a un líder que está en las primeras fases. Sus "capacidades del líder" y "gestión de equipo" están en desarrollo y aún requieren trabajo. Estos líderes se caracterizan por su voluntad de aprender y mejorar a través del conocimiento, la experiencia y la confianza. Suelen ser prácticos, pero carecen de comunicación fluida y empoderamiento al equipo. Son ideales candidatos para recibir capacitaciones, coaching y mentoring.',
    estrellas: 1
  },
  'Liderazgo intermedio': {
    rango: '21 - 40',
    texto: 'En este nivel, el líder ha consolidado algunas de sus "capacidades del líder" y ha alcanzado un grado de madurez mediano en la "gestión de equipo". Sin embargo, todavía tiene áreas de mejora para desarrollar habilidades estratégicas más profundas. Es un líder que comunica bien al colectivo, pero sin demasiada profundidad individual. Está en constante crecimiento y en busca de oportunidades para fortalecer su impacto en su equipo y la organización.',
    estrellas: 2
  },
  'Liderazgo avanzado': {
    rango: '41 - 50',
    texto: 'Un líder de nivel avanzado tiene una base sólida de las principales competencias del liderazgo. Tiene las "capacidades del líder" y "gestión de equipo" muy desarrolladas, por lo que es capaz de dirigir con éxito en una amplia gama de situaciones. Este nivel se destaca por su empatía, su capacidad de influir en las personas y en tomar decisiones difíciles con confianza. No obstante, aún tiene un margen de mejora en la resistencia al cambio y en su poder de convencimiento con niveles jerárquicos superiores.',
    estrellas: 3
  },
  'Liderazgo experto': {
    rango: '51 - 80',
    texto: 'El liderazgo experto se distingue por su excelencia en sus "capacidades del líder" y en la "gestión de equipo", lo que le permite tomar decisiones estratégicas con visión a largo plazo. Estos líderes son diestros para adaptarse y sobresalir en contextos adversos. Su capacidad de influencia y su habilidad para generar resultados consistentes los destacan como figuras claves dentro de la organización. No permiten que su ego los sobre pase y son considerados comúnmente como ejemplos a seguir.',
    estrellas: 4
  },
  'Liderazgo transformacional': {
    rango: '81 - 100',
    texto: 'Este es el nivel de liderazgo más alto, donde el líder no solo gestiona y dirige con excelencia, sino que también inspira y transforma a su equipo y entorno a través del propósito. Los líderes transformacionales son agentes de cambio, capaces de generar un impacto profundo y duradero en las personas y la cultura de la organización. Son visionarios y motivadores. Logran un alto nivel de compromiso y consiguen los resultados cuidando el balance y bienestar de las personas.',
    estrellas: 5
  }
};

const ResultadoPopup = ({ usuario, puntuacion, nivelLiderazgo, onCerrar }) => {
  const infoNivel = nivelesLiderazgo[nivelLiderazgo] || nivelesLiderazgo['Liderazgo en desarrollo'];
  const porcentajeProgreso = Math.min((puntuacion / 100) * 100, 100);

  const descargarPDF = async () => {
    const elemento = document.getElementById('resultado-popup-contenido');
    
    const canvas = await html2canvas(elemento, {
      scale: 2,
      logging: false,
      useCORS: true,
      backgroundColor: '#3D3C43',
      windowWidth: 1200,
      width: 900,
      // Usar onclone para forzar estilos de escritorio en el clon
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.getElementById('resultado-popup-contenido');
        if (clonedElement) {
          // Forzar ancho de escritorio
          clonedElement.style.width = '900px';
          clonedElement.style.minWidth = '900px';
          clonedElement.style.maxWidth = '900px';
          clonedElement.classList.add('pdf-desktop-mode');
          
          // Ocultar botones en el clon
          const btnCerrar = clonedElement.querySelector('.btn-cerrar');
          const btnDescargar = clonedElement.querySelector('.btn-descargar');
          if (btnCerrar) btnCerrar.style.display = 'none';
          if (btnDescargar) btnDescargar.style.display = 'none';
          
          // Forzar estilos de escritorio directamente en los elementos clonados
          const contenido = clonedElement.querySelector('.resultado-contenido');
          if (contenido) {
            contenido.style.cssText = `
              display: flex !important;
              flex-direction: row !important;
              padding: 60px 80px !important;
              gap: 80px !important;
              align-items: center !important;
            `;
          }
          
          const izquierda = clonedElement.querySelector('.resultado-izquierda');
          if (izquierda) {
            izquierda.style.cssText = `flex: 1 !important; text-align: left !important;`;
          }
          
          const nombre = clonedElement.querySelector('.usuario-nombre');
          if (nombre) {
            nombre.style.cssText = `font-size: 40px !important; text-align: left !important;`;
          }
          
          const nivelTitulo = clonedElement.querySelector('.nivel-titulo');
          if (nivelTitulo) {
            nivelTitulo.style.cssText = `font-size: 22px !important; text-align: left !important;`;
          }
          
          const estrellas = clonedElement.querySelector('.estrellas');
          if (estrellas) {
            estrellas.style.cssText = `font-size: 36px !important; justify-content: flex-start !important;`;
          }
          
          const descripcion = clonedElement.querySelector('.nivel-descripcion');
          if (descripcion) {
            descripcion.style.cssText = `font-size: 16px !important; text-align: left !important;`;
          }
          
          const circulo = clonedElement.querySelector('.circulo-progreso');
          if (circulo) {
            circulo.style.cssText = `width: 320px !important; height: 320px !important;`;
          }
          
          const puntuacionNumero = clonedElement.querySelector('.puntuacion-numero');
          if (puntuacionNumero) {
            puntuacionNumero.style.cssText = `font-size: 72px !important;`;
          }
          
          const puntuacionLabel = clonedElement.querySelector('.puntuacion-label-resultado');
          if (puntuacionLabel) {
            puntuacionLabel.style.cssText = `font-size: 24px !important;`;
          }
          
          const logoPdf = clonedElement.querySelector('.logo-pdf');
          if (logoPdf) {
            logoPdf.style.cssText = `position: absolute !important; top: 24px !important; right: 80px !important; height: 50px !important; margin: 0 !important;`;
          }
          
          const footerPdf = clonedElement.querySelector('.footer-pdf');
          if (footerPdf) {
            footerPdf.style.cssText = `padding: 24px 80px 32px !important;`;
          }
          
          const websiteLink = clonedElement.querySelector('.website-link');
          if (websiteLink) {
            websiteLink.style.cssText = `font-size: 16px !important;`;
          }
        }
      }
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: [canvas.width, canvas.height]
    });

    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save(`Resultado_Liderazgo_${usuario}_${new Date().toLocaleDateString()}.pdf`);
  };

  return (
    <div className="resultado-overlay">
      <div className="resultado-popup" id="resultado-popup-contenido">
        <button className="btn-cerrar" onClick={onCerrar}>×</button>
        
        <img 
          src="/logo-rv-blanco.avif" 
          alt="Logo RV" 
          className="logo-pdf"
        />
        
        <div className="resultado-contenido">
          <div className="resultado-izquierda">
            <h2 className="usuario-nombre">{usuario}</h2>
            <p className="nivel-titulo">Nivel de liderazgo: <span className="nivel-valor">{nivelLiderazgo}</span></p>
            
            <div className="estrellas">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={`estrella ${i < infoNivel.estrellas ? 'llena' : ''}`}>★</span>
              ))}
            </div>
            
            <p className="nivel-descripcion">{infoNivel.texto}</p>
            
            <button className="btn-descargar" onClick={descargarPDF}>📥 Descargar PDF</button>
          </div>
          
          <div className="resultado-derecha">
            <div className="circulo-progreso">
              <svg viewBox="0 0 200 200" className="circulo-svg">
                <circle
                  cx="100"
                  cy="100"
                  r="85"
                  fill="none"
                  stroke="#4a4a4a"
                  strokeWidth="15"
                />
                <circle
                  cx="100"
                  cy="100"
                  r="85"
                  fill="none"
                  stroke="#b8b8b8"
                  strokeWidth="15"
                  strokeDasharray={`${2 * Math.PI * 85}`}
                  strokeDashoffset={`${2 * Math.PI * 85 * (1 - porcentajeProgreso / 100)}`}
                  strokeLinecap="round"
                  transform="rotate(-90 100 100)"
                />
              </svg>
              <div className="circulo-texto">
                <span className="puntuacion-numero">{Math.round(puntuacion)}</span>
                <span className="puntuacion-label-resultado">Puntos</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-pdf">
          <a 
            href="https://www.rodrigovillanuevallanos.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="website-link"
          >
            www.rodrigovillanuevallanos.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResultadoPopup;

